var _style, _path, _path2, _path3, _polyline, _path4, _polyline2, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCumulusLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 3818.1 1796.3",
    style: {
      enableBackground: "new 0 0 3818.1 1796.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#EAEFF9;stroke-width:73;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1187.5,898.2c-3.4-159.3,88.9-305.5,233-369.5c150-66.7,327.9-31.7,443.4,87.7 c-15.4-256.5,175.8-481.8,428.4-508.6c248.2-26.3,479.5,147.2,523.6,395.8c223.3-186.1,555.4-170.3,759.1,35.1 c205.4,207,216.9,542.6,25.1,764.1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M440.9,1134.9c-180.4-110.2-388.3,0-388.3,197.9c0,187.9,240.5,303.1,388.3,187.9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M616.3,1091.2V1438c19.9,76.4,87.8,130.6,165.4,132.8c81.1,2.3,154.5-52.8,175.4-132.8c0-115.6,0-231.2,0-346.8 "
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "1139.9,1555.8 1175,1104.8 1187.4,1104.8 1365.4,1465.6 1538.3,1104.8 1558.3,1104.8 1595.9,1555.8  "
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1781.3,1104.8v340.7c25,71.4,92.5,119.7,167.9,120.3c76.3,0.5,145.1-48,170.4-120.3c0-113.6,0-227.1,0-340.7"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "2322.4,1104.8 2322.4,1565.8 2570.5,1566.8 "
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2673.2,1104.8V1433c19.7,82.5,94.7,140.1,177.9,137.8c79.6-2.2,149.1-58.9,167.9-137.8 c0-109.4,0-218.8,0-328.2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3424.8,1117.4c-70.1-50.1-221.1-37.7-240.5,62.6c-15,77.7,46.2,111.3,137.8,149 c81.1,45.5,142.8,43.9,122.8,151.6c-16.7,90-160.3,107.7-258,50.1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCumulusLogo);
export default __webpack_public_path__ + "static/media/Cumulus_Logo.dbd7f9f8781ed5d201b9a25a555fe693.svg";
export { ForwardRef as ReactComponent };